// extracted by mini-css-extract-plugin
export default {"card":"dailyMentions_card__nOG9r","title":"dailyMentions_title__h5BZn","chart":"dailyMentions_chart__xnEUS","empty":"dailyMentions_empty__Yfc3T"};